export default "__VITE_ASSET__BR9JJ3zx__"